import { useEffect, useState } from 'react';
import { ClosestChallenge } from '../../../interfaces/ClosestChallenge';
import { challengeHomeService } from '../../../services/challengeHomeService';

export const useClosestChallenge = () => {
  const [closestChallenge, setClosestChallenge] = useState<ClosestChallenge | null>(null);

  const fetchClosestChallenge = async () => {
    const data = await challengeHomeService.getClosestChallenge();
    setClosestChallenge(data);
  };

  useEffect(() => {
    fetchClosestChallenge();
  }, []);

  return { closestChallenge };
};
